export const formatCharacterCount = (current: number = 0, max: number = 210) => `${current}/${max}`;
